import { createBrowserRouter } from 'react-router-dom'

import { ErrorPage } from '@ps/common-features/pages/ErrorPage/ErrorPage'
import { ServiceTrackingPage } from 'src/pages/service-tracking/ServiceTrackingPage'

import App from './app/App'
import { RouteNotFound } from './pages/404/RouteNotFound'

const redirectTo404 = () => {
  window.location.href = '/404'
  return null
}

export const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      {
        errorElement: <ErrorPage />,
        children: [
          {
            index: true,
            loader: redirectTo404,
          },
          {
            path: 'tracking/:trackingId',
            element: <ServiceTrackingPage />,
          },
          {
            path: '404',
            element: <RouteNotFound />,
          },
          {
            path: '*',
            loader: redirectTo404,
          },
        ],
      },
    ],
  },
])

export default router
